/**
 * Design tokens from Figma Clutter | Handoff — Storage plan (Desktop 03/04).
 * Mapped to values used by the challenger consolidated funnel page.
 */
export const CHALLENGER = {
  color: {
    textPrimary: '#040711',
    textSecondary: '#1f2f38',
    textTertiary: '#66686e',
    /** Figma text/content/text-subtle */
    textSubtle: '#9aa1a5',
    textInverse: '#f6f7f5',
    textDisabled: 'rgba(154, 161, 165, 0.3)',
    textBrand: '#0b7a7a',
    /** Figma text/content/text-brand-dark */
    textBrandDark: '#0b7a7a',
    /** Figma text/content/text-error */
    textError: '#e74c3c',
    linkBrand: '#0b7a7a',
    borderDefault: 'rgba(154, 161, 165, 0.3)',
    borderLight: 'rgba(154, 161, 165, 0.2)',
    borderBrand: '#0b7a7a',
    bgPage: '#f6f7f5',
    bgPrimary: '#ffffff',
    bgSelected: 'rgba(8, 170, 168, 0.12)',
    bgBrandSecondary: 'rgba(198, 170, 119, 0.2)',
    bgPill: '#0b7a7a',
    bgButtonDisabled: 'rgba(154, 161, 165, 0.2)',
    /** Figma background/button/light/button-bg-secondary-default */
    bgButtonSecondaryDefault: 'rgba(154, 161, 165, 0.2)',
    /** Figma background/button/light/button-bg-secondary-hover */
    bgButtonSecondaryHover: '#c8d1d3',
    /** Figma mobile sticky / sheet surface */
    stickySurface: '#f3f1eb',
    timelineSurface: '#e6e2d7',
    overlay: 'rgba(4, 7, 17, 0.3)',
    iconBrand: '#08aaa8',
    iconBrandSecondary: '#c6aa77',
    summarySurface: 'rgba(230, 226, 215, 0.5)',
  },
  /**
   * Figma Avenir Next mapping:
   * Regular → FontWeight.Regular (400)
   * Medium → FontWeight.Medium (500)
   * Demi Bold → FontWeight.Semibold (600) — not Bold (700)
   */
  weight: {
    regular: 400,
    medium: 500,
    demiBold: 600,
  },
  space: {
    4: '4px',
    8: '8px',
    12: '12px',
    16: '16px',
    24: '24px',
    32: '32px',
    48: '48px',
    64: '64px',
    128: '128px',
  },
  radius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '20px',
    pill: '999px',
  },
  font: {
    sans: '"Avenir Next", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  layout: {
    /** Marks `ChallengerLayout` root; `Page` is transparent only under this ancestor. */
    surfaceClassName: 'challenger-layout-surface',
    contentWidth: '720px',
    summaryWidth: '352px',
    columnGap: '48px',
    contentPaddingLeft: '110px',
    /** Figma 707:21173 / 2291:38561 — viewport-fixed mountain panel (not page scroll). */
    mountainPanel: {
      width: '726px',
      height: '580px',
      /** Negative right offset so the graphic bleeds off the window edge. */
      right: '-282px',
    },
  },
  /**
   * Challenger funnel breakpoints (ENG-1124):
   * mobile <768px, tablet 768–1279px, desktop ≥1280px.
   *
   * `media.mobile` and `media.desktop` are not a contiguous pair — tablet sits
   * between them. Import `MOBILE` / `TABLET` / `TABLET_UP` / `DESKTOP` from
   * `./media` instead of using these strings directly.
   */
  breakpoints: {
    mobileMaxPx: 767,
    tabletMinPx: 768,
    tabletMaxPx: 1279,
    desktopMinPx: 1280,
  },
  media: {
    mobile: '@media (max-width: 767px)',
    tablet: '@media (min-width: 768px) and (max-width: 1279px)',
    tabletUp: '@media (min-width: 768px)',
    desktop: '@media (min-width: 1280px)',
  },
} as const;
